import { render, staticRenderFns } from "./rightVideo.vue?vue&type=template&id=3502f6c0&scoped=true"
import script from "./rightVideo.vue?vue&type=script&lang=js"
export * from "./rightVideo.vue?vue&type=script&lang=js"
import style0 from "./rightVideo.vue?vue&type=style&index=0&id=3502f6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502f6c0",
  null
  
)

export default component.exports